import { useRoadConditionsSearchListQuery } from '@kinetic-ui/data-layer';
import {
  getNodes,
  MapSearchResultItem,
  MapSearchResultProps,
  RoadCondtionIcon,
  useMapBoxSearchContext,
} from '@kinetic-ui/shared';
import { Fragment, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ENTITY_DRAWER_VIEW_ALL_ROUTE, ENTITY_EDIT_ROUTE } from '../EntityList/const';
import { filterRoadConditions } from 'kineticUtils';

const MapSearchResult: React.FC<MapSearchResultProps> = ({ isAppSearch, onResultClick }) => {
  const { searchText } = useMapBoxSearchContext();
  const { push } = useHistory();

  const { data } = useRoadConditionsSearchListQuery({
    variables: {
      filters: filterRoadConditions(),
      searchText,
      limit: 5,
    },
  });

  const onClick = useCallback(
    (id: string) => {
      if (isAppSearch) {
        push(`/${ENTITY_EDIT_ROUTE}/${id}`);
        if (onResultClick) {
          onResultClick();
        }
        return;
      }

      push(`/${ENTITY_DRAWER_VIEW_ALL_ROUTE}/${id}`);
    },
    [isAppSearch, onResultClick, push]
  );

  return (
    <Fragment>
      {getNodes(data?.events).map(({ id, attributes, name }) => (
        <MapSearchResultItem
          icon={<RoadCondtionIcon style={{ fill: '#000' }} />}
          name={`${name} - ${attributes.JURISDICTION}`}
          onClick={() => onClick(id)}
          key={`searchItem_${id}`}
        />
      ))}
    </Fragment>
  );
};

export default MapSearchResult;
